import { ClickoutUrl } from '@/helpers/clickout-helper';
import { useExperiment } from '@/libraries/experiment';
import { getExperimentAffiliateTag } from '@/libraries/experiment/experiment-affiliation';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { computed } from 'vue';

const config = {
	variant_1: {
		swiperDelay: 50000,
		adUnit: 'exp_underperforming_urls_4_V1',
	},
	variant_2: {
		swiperDelay: 50000,
		adUnit: 'exp_underperforming_urls_4_V2',
	},
	variant_3: {
		swiperDelay: 15000,
		adUnit: 'exp_underperforming_urls_4_V3',
	},
	variant_4: {
		swiperDelay: 15000,
		adUnit: 'exp_underperforming_urls_4_V4',
	},
} as const;

export default function useUnderPerformingUrlsExp() {
	const languageStore = useLanguageStore();
	const { activeVariantWithControlGroup: variant, experimentInfo } = useExperiment('EXP_UNDERPERFORMING_URLS_4');

	const swiperDelay = computed(() => {
		if (!variant.value || variant.value === 'control') return null;

		return config[variant.value]?.swiperDelay || null;
	});

	const adUnit = computed(() => {
		if (!variant.value || variant.value === 'control') return null;

		return config[variant.value]?.adUnit || null;
	});

	function setUnderPerformingUrlsExpTags(url: ClickoutUrl, placement: 'ft' | 'sqtv' | 'qtv', shortName: string) {
		if (!variant.value) return url;

		const affiliationShortId = experimentInfo.value.affiliationShortId as string;

		const tag = getExperimentAffiliateTag({
			affiliationShortId,
			variant: variant.value,
			country: languageStore.country,
			placement,
			providerShortName: shortName,
		});

		url.set('uct_ctag', tag);

		return url;
	}

	return {
		setUnderPerformingUrlsExpTags,
		swiperDelay,
		adUnit,
	};
}
